import { render, staticRenderFns } from "./MetaCompetitors.vue?vue&type=template&id=59d5856e&scoped=true&"
import script from "./MetaCompetitors.vue?vue&type=script&lang=ts&"
export * from "./MetaCompetitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d5856e",
  null
  
)

export default component.exports